"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupCheckbox = GroupCheckbox;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _validators = require("../validators");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function GroupCheckbox(_ref) {
  var label = _ref.label,
    name = _ref.name,
    value = _ref.value,
    options = _ref.options,
    row = _ref.row,
    required = _ref.required,
    disabled = _ref.disabled,
    onChanged = _ref.onChanged;
  var items = (0, _react.useMemo)(function () {
    return options.values.map(function (el, index) {
      var _a;
      return {
        value: el,
        label: options.labels ? (_a = options.labels[index]) !== null && _a !== void 0 ? _a : el : el,
        checked: value.indexOf(el) >= 0,
        disabled: !!disabled && disabled.indexOf(el) >= 0
      };
    });
  }, [options, value, disabled]);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    blured = _useState2[0],
    setBlured = _useState2[1];
  var _useState3 = (0, _react.useState)({
      name: name,
      value: value !== null && value !== void 0 ? value : [],
      valid: true,
      blured: false,
      blurer: setBlured,
      reset: function reset() {
        setValidation(function (v) {
          return Object.assign(Object.assign({}, v), {
            value: [],
            valid: true,
            blured: false
          });
        });
      }
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    validation = _useState4[0],
    setValidation = _useState4[1];
  var validate = (0, _react.useCallback)(function (targetValue) {
    var valid = !required || targetValue.length > 0;
    setValidation(function (validation) {
      return Object.assign(Object.assign({}, validation), {
        value: targetValue,
        valid: valid,
        error: valid ? undefined : _validators.TEXT_REQUIRED_VALIDATOR.getMessage()
      });
    });
  }, [required]);
  (0, _react.useEffect)(function () {
    // se solicita una validación inicialmente
    validate(value);
  }, [value, validate]);
  (0, _react.useEffect)(function () {
    // se reporta cada cambio en la referencia
    onChanged(validation.name, validation.value, validation);
    // eslint-disable-next-line
  }, [validation]);
  var handleChange = function handleChange(index) {
    return function (event, checked) {
      if (!blured) {
        setBlured(true);
      }
      var newValues = items.map(function (el, i) {
        if (i === index) {
          el.checked = checked;
        }
        return el;
      }).filter(function (el) {
        return el.checked;
      }).map(function (el) {
        return el.value;
      });
      validate(newValues);
    };
  };
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
    required: required,
    error: blured && validation && !validation.valid,
    component: "fieldset",
    focused: false
  }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
    component: "legend"
  }, label), /*#__PURE__*/_react["default"].createElement(_material.FormGroup, {
    row: row
  }, items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
      key: item.value,
      control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
        checked: item.checked,
        onChange: handleChange(index),
        value: item.value
      }),
      label: item.label,
      disabled: item.disabled,
      componentsProps: {
        typography: {
          variant: 'body2'
        }
      }
    });
  }), options.values.length === 0 && (/*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "overline",
    component: "span"
  }, (0, _core.translate)('no_values')))), blured && validation && !validation.valid && (/*#__PURE__*/_react["default"].createElement(_material.FormHelperText, null, validation.error))));
}